import _ from 'lodash';
import moment from 'moment';
import '@mescius/wijmo.cultures/wijmo.culture.ja';
import { InputDate, InputNumber } from '@mescius/wijmo.input';

import { DATE_TIME_FORMAT, INDEX_OF_GRID_COLUMN } from './constants';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { isIPad } from './commonUtil';

export const SCHEDULE_COLUMN_NAME = [
  {
    binding: 'name',
    header: '工種・場所',
    cssClassAll: 'wj-column-name wj-text-white wj-bg-black',
    minWidth: 280,
    maxWidth: 550,
  },
  {
    header: '計画工期',
    align: 'center',
    columns: [
      {
        binding: 'start_date',
        header: '開始予定日',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green',
      },
      {
        binding: 'end_date',
        header: '終了予定日',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green',
      },
      {
        binding: 'plan_work_days',
        header: '稼働日数',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
      },
    ],
  },
  {
    binding: 'quantity',
    header: '計画数量',
    align: 'center',
    cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
  },
  {
    binding: 'productivity',
    header: '計画歩掛',
    align: 'center',
    cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
  },
  {
    header: '計画人工',
    align: 'center',
    columns: [
      {
        binding: 'total_man_days',
        header: '延べ',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
      },
      {
        binding: 'mans_per_day',
        header: '1日あたり',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
      },
    ],
  },
  {
    header: '工期',
    align: 'center',
    columns: [
      {
        binding: 'result_end_date',
        format: 'yyyy/MM/dd',
        header: '終了日(実績)',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue',
      },
      {
        binding: 'elapsed_days',
        header: '経過日数',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        minWidth: 100,
      },
    ],
  },
  {
    header: '人工',
    align: 'center',
    columns: [
      {
        binding: 'plan_man_hours',
        header: '計画',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
      {
        binding: 'schedule_man_hours',
        header: '予定',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
      {
        binding: 'result_man_hours',
        header: '実績',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
      {
        binding: 'plan_result_diff_man_hours',
        header: '計画実績差分',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
    ],
  },
  {
    header: '数量',
    align: 'center',
    columns: [
      {
        binding: 'plan_amount',
        header: '計画',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
      {
        binding: 'result_amount',
        header: '実績',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
      {
        binding: 'plan_result_diff_amount',
        header: '計画実績差分',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
    ],
  },
  {
    header: '歩掛',
    align: 'center',
    columns: [
      {
        binding: 'plan_productivity',
        header: '計画',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        minWidth: 60,
      },
      {
        binding: 'result_productivity',
        header: '実績',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        minWidth: 60,
      },
      {
        binding: 'plan_result_diff_productivity',
        header: '計画実績差分',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
    ],
  },
];

export const SCHEDULE_EDIT_COLUMN_NAME = [
  {
    binding: 'name',
    header: '工種・場所',
    cssClassAll: 'wj-column-name wj-text-white wj-bg-black',
    minWidth: 280,
    maxWidth: 550,
    isRequired: false,
  },
  {
    header: '計画工期',
    align: 'center',
    columns: [
      {
        binding: 'start_date',
        header: '開始予定日',
        format: 'yyyy/MM/dd',
        isRequired: false,
        editor: new InputDate(document.createElement('div'), {
          format: 'yyyy/MM/dd',
          isRequired: false,
        }),
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green',
        minWidth: 125,
      },
      {
        binding: 'end_date',
        format: 'yyyy/MM/dd',
        isRequired: false,
        editor: new InputDate(document.createElement('div'), {
          format: 'yyyy/MM/dd',
          isRequired: false,
        }),
        header: '終了予定日',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green',
        minWidth: 125,
      },
      {
        binding: 'plan_work_days',
        header: '稼働日数',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
        minWidth: 150,
        isRequired: false,
      },
    ],
  },
  {
    binding: 'quantity',
    editor: new InputNumber(document.createElement('div'), {
      isRequired: false,
      min: 0,
    }),
    isRequired: false,
    header: '計画数量',
    align: 'center',
    cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
  },
  {
    binding: 'productivity',
    editor: new InputNumber(document.createElement('div'), {
      isRequired: false,
      min: 0,
    }),
    header: '計画歩掛',
    align: 'center',
    isRequired: false,
    cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
  },
  {
    header: '計画人工',
    align: 'center',
    columns: [
      {
        binding: 'total_man_days',
        header: '延べ',
        align: 'center',
        editor: new InputNumber(document.createElement('div'), {
          isRequired: false,
          min: 0,
        }),
        isRequired: false,
        cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
      },
      {
        binding: 'mans_per_day',
        header: '1日あたり',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-green wj-align-right',
        isRequired: false,
      },
    ],
  },
  {
    header: '工期',
    align: 'center',
    columns: [
      {
        binding: 'result_end_date',
        format: 'yyyy/MM/dd',
        header: '終了日(実績)',
        align: 'center',
        isRequired: false,
        editor: new InputDate(document.createElement('div'), {
          format: 'yyyy/MM/dd',
          isRequired: false,
        }),
        cssClassAll: 'wj-text-white wj-bg-blue',
        minWidth: 125,
      },
      {
        binding: 'elapsed_days',
        header: '経過日数',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        minWidth: 100,
        isRequired: false,
      },
    ],
  },
  {
    header: '人工',
    align: 'center',
    columns: [
      {
        binding: 'plan_man_hours',
        header: '計画',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        isRequired: false,
      },
      {
        binding: 'schedule_man_hours',
        header: '予定',
        isRequired: false,
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
      {
        binding: 'result_man_hours',
        header: '実績',
        isRequired: false,
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
      {
        binding: 'plan_result_diff_man_hours',
        header: '計画実績差分',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        isRequired: false,
      },
    ],
  },
  {
    header: '数量',
    align: 'center',
    columns: [
      {
        binding: 'plan_amount',
        header: '計画',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        isRequired: false,
      },
      {
        binding: 'result_amount',
        header: '実績',
        align: 'center',
        editor: new InputNumber(document.createElement('div'), {
          isRequired: false,
          min: 0,
        }),
        isRequired: false,
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
      },
      {
        binding: 'plan_result_diff_amount',
        header: '計画実績差分',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        isRequired: false,
      },
    ],
  },
  {
    header: '歩掛',
    align: 'center',
    columns: [
      {
        binding: 'plan_productivity',
        header: '計画',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        minWidth: 60,
        isRequired: false,
      },
      {
        binding: 'result_productivity',
        header: '実績',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        minWidth: 60,
        isRequired: false,
      },
      {
        binding: 'plan_result_diff_productivity',
        header: '計画実績差分',
        align: 'center',
        cssClassAll: 'wj-text-white wj-bg-blue wj-align-right',
        isRequired: false,
      },
    ],
  },
];

export const SETTING_COLUMN_NAME = [
  {
    header: '工種',
    columns: [
      {
        binding: 'main_work_type_name',
        header: '大工種',
        isReadOnly: true,
        maxWidth: 250,
        cssClassAll: 'wj-align-left wj-text-color wj-background wj-bg-blue',
      },
      {
        binding: 'sub_work_type_name',
        header: '小工種',
        isReadOnly: true,
        maxWidth: 250,
        cssClassAll: 'wj-align-left wj-text-color wj-background wj-bg-blue',
      },
    ],
  },
  {
    binding: 'unit_name',
    header: '計画数量 単位',
    isReadOnly: true,
    width: 85,
    cssClassAll:
      'wj-align-center wj-text-color wj-background wj-bg-blue wj-unit',
  },
  {
    binding: 'input_type',
    header: '入力方法',
    isReadOnly: true,
    cssClassAll: 'wj-align-center wj-text-color wj-background',
  },
];

export const COLUMN_REQUIRE = {
  header: '必須設定',
  isReadOnly: true,
  cssClassAll: 'wj-align-center wj-text-color wj-background',
};

export const COLUMN_DISPLAY_SUB_FLAG = [
  'start_date',
  'end_date',
  'plan_work_days',
  'mans_per_day',
  'result_end_date',
  'elapsed_days',
];

export const COLUMN_DISPLAY_MAIN_FLAG = [
  ...COLUMN_DISPLAY_SUB_FLAG,
  'quantity',
  'productivity',
  'plan_amount',
  'result_amount',
  'plan_result_diff_amount',
  'plan_productivity',
  'result_productivity',
  'plan_result_diff_productivity',
];

export const COLUMN_EDIT_PERMISSION = [
  'start_date',
  'end_date',
  'quantity',
  'productivity',
  'total_man_days',
  'result_end_date',
  'result_amount',
];

export const COLUMN_NUMBER = [
  'productivity',
  'total_man_days',
  'mans_per_day',
  'plan_man_hours',
  'schedule_man_hours',
  'result_man_hours',
  'plan_result_diff_man_hours',
  'plan_amount',
  'plan_result_diff_amount',
  'plan_productivity',
  'result_productivity',
  'plan_result_diff_productivity',
];

export const DATA_TYPE = [0, 1, 2, 3, 4, 5];

export const KEY_GROUP_OF_WORK_TYPE = [
  'field_sub_work_type_id',
  'place_id',
  'place_id',
  'place_id',
  'place_id',
];
export const KEY_GROUP_OF_PLACE_TYPE = [
  'field_main_work_type_id',
  'field_sub_work_type_id',
  'place_id',
  'place_id',
  'place_id',
];

export const INIT_POSITION = 0;

export const VIEW_RANGE_BOTTOM_HEIGHT = 10;

export const TOOLTIP_WARNING =
  '作業予定・作業実績入力期間の範囲外の日が設定されています。 範囲外の作業予定・実績の人工は集計されませんので、ご注意ください。';

export const IS_PLAN_TAB_FLG = 0;
export const IS_RESULT_TAB_FLG = 1;

export const PATTERN_NUMBER = /^[0-9]\d*(((,\d{0,}){1})*(\.\d{0,})?((,\d{1,}){1})*)$/;

export const MAX_NUMBER_VALIDATOR = 999999.99;
export const MAX_NUMBER_VALIDATOR_PRODUCTIVITY = 999.99;

export const setMathRoundNumber = value => {
  return _.isNull(value) ? null : Math.round(value * 100) / 100;
};

export const setDisplayTab = (flexGrid, type) => {
  const isVisible = !type;
  for (
    let i = INDEX_OF_GRID_COLUMN.start_date;
    i <= INDEX_OF_GRID_COLUMN.mans_per_day;
    i++
  ) {
    flexGrid.columns[i].visible = isVisible;
  }
  for (
    let i = INDEX_OF_GRID_COLUMN.result_end_date;
    i <= INDEX_OF_GRID_COLUMN.plan_result_diff_productivity;
    i++
  ) {
    flexGrid.columns[i].visible = !isVisible;
  }
};

export const initColumnGroupByTab = (columnGroups, type) => {
  const listColumns = _.flatMap(columnGroups, group => group.columns || group);
  const isVisible = !type;
  for (
    let i = INDEX_OF_GRID_COLUMN.start_date;
    i <= INDEX_OF_GRID_COLUMN.mans_per_day;
    i++
  ) {
    listColumns[i].visible = isVisible;
  }
  for (
    let i = INDEX_OF_GRID_COLUMN.result_end_date;
    i <= INDEX_OF_GRID_COLUMN.plan_result_diff_productivity;
    i++
  ) {
    listColumns[i].visible = !isVisible;
  }
  return columnGroups;
};

export const setStyleForCell = (row, isWorkType, id, isReadOnly = false) => {
  const classEdit = 'wj-row-editable';
  const classDefault = 'wj-bg-default wj-border-solid';
  const classGray = 'wj-bg-gray wj-border-dotted';
  const classWhite = 'wj-bg-white wj-border-dotted';
  const classMargin = 'wj-ml-17';
  const classMarginPlace = 'wj-ml-4';
  let className = classWhite;

  const setClassForCell = (
    row,
    mainWorkClass,
    subWorkClass,
    otherClass,
    placeClass = null
  ) => {
    switch (row._data.data_type) {
      case DATA_TYPE[0]:
        className = mainWorkClass;
        break;
      case DATA_TYPE[1]:
        className = subWorkClass;
        break;
      case DATA_TYPE[id + 1]:
        className = placeClass;
        break;
      default:
        className = otherClass;
    }
  };
  if (isWorkType) {
    if (_.isEmpty(row._data.child)) {
      row.isReadOnly = isReadOnly;
      setClassForCell(
        row,
        `${classDefault} ${classEdit} ${classMargin}`,
        `${classGray} ${classEdit} ${classMargin}`,
        `${classWhite} ${classEdit} ${classMarginPlace}`
      );
    } else {
      setClassForCell(
        row,
        classDefault,
        classGray,
        `${classWhite} ${classMarginPlace}`
      );
    }
  } else {
    if (_.isEmpty(row._data.child)) {
      row.isReadOnly = isReadOnly;
      setClassForCell(
        row,
        `${classGray} ${classEdit} ${classMargin}`,
        `${classGray} ${classEdit} ${classMargin}`,
        `${classWhite} ${classEdit} ${classMarginPlace}`,
        `${classDefault} ${classEdit} ${classMargin}`
      );
    } else {
      setClassForCell(
        row,
        classGray,
        classGray,
        `${classWhite} ${classMarginPlace}`,
        classDefault
      );
    }
  }
  row._cssClass = className;
};

export const setIconArrowForCell = (
  isWorkType = true,
  workTypeId = null,
  domCell,
  row,
  result
) => {
  const arrayOfWorkType = [2, 3, 4, 5];
  const arrayOfPlaceType = _.filter(
    arrayOfWorkType,
    item => !_.isEqual(item, workTypeId + 1)
  );
  if (
    _.includes(isWorkType ? arrayOfWorkType : arrayOfPlaceType, row.data_type)
  ) {
    if (!_.isEmpty(row.child)) {
      domCell.firstChild.remove();
    }
    const icon = document.createElement('i');
    icon.className = 'icon-subdirectory';
    result.appendChild(icon);
  }
};

export const setNewDataType = id => {
  const handleCreateNewDataType = id => {
    let newDataType = _.filter(DATA_TYPE, item => !_.isEqual(item, id));
    newDataType = [id, ...newDataType];
    return newDataType;
  };
  let dataType;
  switch (id) {
    case DATA_TYPE[1]:
      dataType = handleCreateNewDataType(DATA_TYPE[2]);
      break;
    case DATA_TYPE[2]:
      dataType = handleCreateNewDataType(DATA_TYPE[3]);
      break;
    case DATA_TYPE[3]:
      dataType = handleCreateNewDataType(DATA_TYPE[4]);
      break;
    case DATA_TYPE[4]:
      dataType = handleCreateNewDataType(DATA_TYPE[5]);
      break;
    default:
      dataType = [...DATA_TYPE];
      break;
  }
  return dataType;
};

export const setFormatData = (dataTypesUnregistered, data, workTypeId) => {
  const listItems = _.cloneDeep(data);
  const dataType = setNewDataType(workTypeId);
  const handleCreateNewFirstItem = (listItems, type) => {
    _.forEach(listItems, item => {
      _.forEach(item.child, itemChild => {
        if (itemChild.is_null && _.includes(dataTypesUnregistered, type)) {
          item.child = [...itemChild.child];
        }
      });
    });
  };
  const handleCreateNewSecondItem = (listItems, type) => {
    _.forEach(listItems, item => {
      handleCreateNewFirstItem(item.child, type);
    });
  };
  const handleCreateNewThirdItem = (listItems, type) => {
    _.forEach(listItems, item => {
      handleCreateNewSecondItem(item.child, type);
    });
  };
  const handleCreateNewLastItem = (listItems, type) => {
    _.forEach(listItems, item => {
      handleCreateNewThirdItem(item.child, type);
    });
  };

  handleCreateNewLastItem(listItems, dataType[4]);
  handleCreateNewThirdItem(listItems, dataType[3]);
  handleCreateNewSecondItem(listItems, dataType[2]);
  handleCreateNewFirstItem(listItems, dataType[1]);
  return listItems;
};

export const getValidFormatDate = date => {
  const formatDate = moment(date, DATE_TIME_FORMAT.slashDateFormat, true);
  return formatDate.isValid()
    ? formatDate.format(DATE_TIME_FORMAT.slashDateFormat)
    : null;
};

export const setMaxHeightTable = (divFixed, params) => {
  const strongNotification = SessionStorageService.getStrongtNotificationCount();
  if (isIPad()) {
    divFixed.style.maxHeight = !strongNotification
      ? params.heghtOfTableIpad
      : params.heightOfTableIpadHaveNoti;
  } else {
    divFixed.style.maxHeight = !strongNotification
      ? params.heightOfTable
      : params.heightOfTableHaveNoti;
  }
};

export const isExistSubItem = (dataTypesUnregistered, item) => {
  let subItem;
  let isExistSubItem;
  if (_.includes(dataTypesUnregistered, DATA_TYPE[1])) {
    subItem = _.find(item.child, item =>
      _.isEqual(item.data_type, DATA_TYPE[1])
    );
    isExistSubItem = !_.isUndefined(subItem);
  } else {
    subItem = _.find(item.child, item => item.is_null);
    isExistSubItem = _.isUndefined(subItem);
  }
  return isExistSubItem;
};

export const POSITION_OF_COLUMN = {
  main_work_type: 0,
  sub_work_type: 1,
  input_type: 3,
};

export const VEHICLE_NUMBER_COLUMNS = [
  {
    binding: 'area',
    header: '地域',
    cssClassAll: 'wj-align-center wj-text-color wj-background wj-align-left',
    width: 215,
  },
  {
    binding: 'class_number',
    header: '分類番号',
    cssClassAll: 'wj-align-center wj-text-color wj-background wj-align-left',
    width: 110,
  },
  {
    binding: 'hiragana',
    header: 'ひらがな',
    cssClassAll: 'wj-align-center wj-text-color wj-background wj-align-left',
    width: 110,
  },
  {
    binding: 'designated_number',
    header: '指定番号',
    cssClassAll: 'wj-align-center wj-text-color wj-background wj-align-left',
    width: 225,
  },
];



// WEBPACK FOOTER //
// ./src/utilities/constWijmo.js